import { Component, createElement } from 'react';
import ReactGA from 'react-ga';

import reporter from '../../utils/reporter';
import config from '../../config';

/**
 * Analytics is a HOC that wraps the app component and uses the router to track user page view
 * information. The Analytics component leverages both Google Analytics and reporting via
 * odin and the reporting service.
 *
 * TODO: Once redirect through the member app are created, these redirects need to trigger
 * a PageViewEvent with a status of 302.
 */
export default Router => (Application) => {
  class Analytics extends Component {
    componentDidMount() {
      // Log initial page view.
      this.logPageView();
      this.logGoogleAnalyticsPageView(window.location.pathname);

      // Add event listener to log all subsequent page views.
      Router.events.on('routeChangeComplete', () => {
        this.logPageView();
        this.logGoogleAnalyticsPageView(Router.asPath);
      });
    }

    logPageView = () => {
      reporter.report('PageViewEvent', {
        occurred_at: Date.now(),
        path: Router.asPath,
        query_parameters: new URLSearchParams(Router.query).toString(),
        status: '201',
      });
    };

    logGoogleAnalyticsPageView = (url) => {
      if (!window.GA_INITIALIZED) {
        ReactGA.initialize(config.googleAnalyticsKey);
        window.GA_INITIALIZED = true;
      }

      ReactGA.set({ page: url, title: document.title, anonymizeIp: true });
      ReactGA.pageview(url);
    }

    render() {
      return createElement(Application, {
        ...this.props,
      });
    }
  }

  if (Application.getInitialProps) {
    Analytics.getInitialProps = Application.getInitialProps;
  }

  return Analytics;
};
